<template>
  <div
    class="container"
    :style="{
      background:
        'url(' +
        require('../../assets/img/' + bei_ing) +
        ') no-repeat center center',
      'background-size': '100% 100%',
    }"
  >
    <dingbu></dingbu>
    <div class="home_content">
      <div class="bg_color">
        <div class="w">
          <div class="inform__box">
            <div class="box__top">
              <span class="shou__ye">首页</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <router-link
                class="ton__zhi2"
                tag="span"
                :to="{ path: '/profile', query: { id: this.id } }"
                >学习系统</router-link
              >
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi2" @click="wodekaoshi">我的考试</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi">考试须知</span>
            </div>
          </div>
          <div class="box-contentvb">
            <div class="kasohi-xuzghi">
              <img
                class="kaoshi_img"
                src="../../assets/kaoshixuzhi_img@2x.png"
                alt
              />
            </div>
            <div class="kaoshi-right">
              <div class="kaoshi-xuzhi-title">考试须知</div>
              <div class="xuzhi-xian"></div>
              <div class="xuzhi-text" v-html="extrm.content"></div>
              <div class="kaishi-kao" @click="kaikao">开始考试</div>
            </div>
          </div>
        </div>
        <dibu></dibu>
        <daohan></daohan>
      </div>
    </div>
    <!-- 认证失败弹窗 - 不可关闭 -->
    <div v-if="failModalVisible" class="fail-modal">
      <div class="fail-modal-content">
        <div class="fail-modal-header">
          <span class="fail-icon">⚠️</span>
          <span>认证失败</span>
        </div>
        <div class="fail-modal-body">
          <p>{{ failMessage }}</p>
          <p class="fail-tip">请重新认证或联系客服</p>
        </div>
        <div class="fail-modal-footer">
          <button @click="contactSupport" class="contact-btn">联系客服</button>
          <button @click="retryAuth" class="retry-auth-btn">重新认证</button>
        </div>
      </div>
    </div>
    <div v-if="authModalVisible" class="fail-modal">
      <div class="fail-modal-content">
        <div class="fail-modal-header">
          <span class="fail-icon">⚠️</span>
          <span>需要认证才能继续</span>
        </div>
        <div class="fail-modal-body">
          <p>{{ failMessage }}</p>
          <p class="fail-tip">请前往认证</p>
        </div>
        <div class="fail-modal-footer">
<!--          <button @click="simulateAuth" class="simulate-btn">模拟认证成功</button>-->
          <button @click="goAuth" class="retry-auth-btn">去认证</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="https://o.alicdn.com/captcha-frontend/aliyunFP/fp.min.js"></script>
<script>

import daohan from "../daohan";
import dibu from "../dibu";
import dingbu from "../dingbu";
export default {
  components: {
    daohan,
    dibu,

    dingbu
  },
  data() {
    return {
      extrm: [],
      id: "",
      bei_ing: this.Public.bei_ing,
      isNeedAuth:false,
      defaultAuthType:'realauth',
      // 认证失败弹窗相关数据
      failModalVisible: false,
      failMessage: '',
      failType: '', // 'realauth' 或 'picture'

      authModalVisible:false,
      authSysParam :null,
      authSysSetParam:null
    };
  },
  mounted() {
    window.addEventListener('pageshow', this.onPageShow);
    this.getexamtext();
    this.id = this.id = this.$route.query.id;
    this.getSysAuthParam()
    // 检查是否从认证返回，有考试意图则重新校验认证
    if(sessionStorage.getItem('examIntent') == 'true'){
      this.kaikao();
    }
  },
  beforeDestroy() {
    window.removeEventListener('pageshow', this.onPageShow);
  },
  methods: {
    onPageShow(event) {
      // 这个判断是可选的，如果你希望无论是否从缓存来都执行，可以不加判断
      if (event.persisted) {
        this.getSysAuthParam()
        // 检查是否从认证返回，有考试意图则重新校验认证
        if(sessionStorage.getItem('examIntent') == 'true'){
          this.kaikao();
        }
      } else {
        console.log('页面是首次正常加载的。');
      }
      // 在这里调用你希望在回退时执行的函数
    },
    getSysAuthParam(){
      this.post('user/getSysAuthParam').then((res)=>{
        if(res.data.real_switch == 1){
          this.defaultAuthType = 'realauth'
        }else{
          this.defaultAuthType = 'picture'
        }
      })
    },
    goAuth(){
      if(this.defaultAuthType == 'picture')
      {
        this.pictureDeal()
      }else{
        this.auth()
      }
    },
    // 模拟认证成功（开发测试用，无需摄像头）
    simulateAuth(){
      this.post('user/changeAuth',{uid:this.$store.state.userid,auth:'authsuccess',field:'exam_auth'}).then(()=>{
        this.$message.success('模拟认证成功');
        this.authModalVisible = false;
        this.isNeedAuth = false;
        this.hideFailModal();
        // 直接创建考试会话并进入答题
        this.doStartExam();
      })
    },
    checkExamAuth(){
      this.post('exam/checkExamAuth').then((res)=>{
        if(res.code == 1){
          if(res.data.isNeedAuth == 'authing')
          {
            this.checkAuth()
          }
          else if(res.data.isNeedAuth == 'authsuccess'){
            this.clearAuthParams()
            this.isNeedAuth = false
            this.hideFailModal()
          }else{
            //需要认证
            this.clearAuthParams()
            this.isNeedAuth = true
            this.showAuthModal()
          }
        }
      })
    },
    setSysParam(){
      let url = 'user/authInfo'
      let sysParam = null
      let authParam = null
      console.log(this.$store.state.userid)
      this.post(url,{uid:this.$store.state.userid}).then((res)=>{
        if(res.code == 1){
          sysParam= res.data.authset
          authParam= res.data.auth
          this.authSysSetParam = sysParam
          this.authSysParam = authParam
          console.log(this.authSysParam)
          if(sysParam.real_switch == 1){
            //需要实人认证
            this.defaultAuthType = 'realauth'
          }else{
            this.defaultAuthType = 'picture'
          }

          if(this.authSysParam.bio == '' || this.authSysParam.bio == 'authsuccess')
          {
            if(localStorage.getItem('authing') != 'false' && this.defaultAuthType == 'picture'){
              this.$message.success('认证成功');
              localStorage.setItem('authing',false)
            }
            this.clearAuthParams()
            this.isNeedAuth = false
          }
          else if(this.authSysParam.bio == 'authing' && this.defaultAuthType == 'realauth')
          {
            this.checkAuth()
          }
          else{
            this.isNeedAuth = true
            this.showFailModal("需要认证",this.defaultAuthType)
          }
        }
      })

    },
    // 实人认证 - 跳转到认证页面
    auth() {
      let that = this, url = "/realauth/getExamCertify"
      let param = {metaInfo: window.getMetaInfo(), returnUrl: window.location.href,uid:this.$store.state.userid}
      this.post(url, param).then(async res => {
        console.log(res.data.certifyUrl)
        console.log(res.data.certifyId)
        this.authCertifyId = res.data.certifyId;
        this.authCertifyUrl = res.data.certifyUrl;
        window.location.href = res.data.certifyUrl;
      }).catch(error => {
        // 请求失败显示弹窗
        this.showFailModal('获取认证信息失败，请稍后重试或联系客服。', 'realauth');
      });
    },

    // 验证实人认证结果（从地址栏参数获取）
    checkAuth() {
      const urlParams = new URLSearchParams(window.location.search);
      const responseStr = urlParams.get('response');
      if (!responseStr) {
        this.$message.warning('未找到认证结果，请先进行认证');
        this.showFailModal('未找到认证结果，请先进行认证','picture')
        return;
      }

      try {
        const responseObj = JSON.parse(decodeURIComponent(responseStr));
        const certifyId = responseObj.extInfo?.certifyId;
        this.authCertifyId = certifyId;
        this.post('/realauth/examCheckCertify', {certifyId: this.authCertifyId,uid:this.$store.state.userid}).then((res) => {
          if (res.code == 1 && res.data.passed == 'T') {
            // 认证成功：刷新页面清除参数
            this.$message.success('认证成功');
            this.clearAuthParams()
          } else {
            // 认证失败：显示不可关闭弹窗
            this.clearAuthParams()
          }
        }).catch((error) => {
          this.showFailModal('认证服务异常，请稍后重试或联系客服。', 'realauth');
        });
      } catch (e) {
        this.showFailModal('认证结果解析失败，请重新认证。', 'realauth');
      }
    },

    // 拍照认证 - 跳转到内部拍照认证页面
    pictureDeal() {
      const urlParams = new URLSearchParams(window.location.search);
      let query = { page: 'exam', uid: this.$store.state.userid }
      for (const [key, value] of urlParams) {
        if (!query.hasOwnProperty(key)) {
          query[key] = value
        }
      }
      this.$router.push({ path: '/authCamera', query: query });
    },

    // 清除URL中的认证相关参数
    clearAuthParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const paramsToRemove = ['response', 'picture','page'];
      paramsToRemove.forEach(param => {
        urlParams.delete(param);
      });

      const newUrl = window.location.href.split('?')[0] + (urlParams.toString() ? '?' + urlParams.toString() : '');
      if (newUrl !== window.location.href) {
          window.history.replaceState({}, '', newUrl);
        // setTimeout(()=>{
        //   window.location.href = newUrl
        // },1000)

      }
    },

    // 显示不可关闭的失败弹窗
    showFailModal(message, type = 'realauth') {
      this.failMessage = message;
      this.failType = type;
      this.failModalVisible = true;
      // 禁止页面滚动
      document.body.style.overflow = 'hidden';

    },
    showAuthModal() {
      this.authModalVisible = true;
      // 禁止页面滚动
      document.body.style.overflow = 'hidden';
    },

    // 关闭失败弹窗（内部使用）
    hideFailModal() {
      this.failModalVisible = false;
      this.failMessage = '';
      this.failType = '';
      // 恢复页面滚动
      document.body.style.overflow = '';
    },

    // 联系客服
    contactSupport() {
      this.isNeedAuth = false
      this.failModalVisible = false
    },

    // 重新认证
    retryAuth() {

      // 关闭弹窗
      this.hideFailModal();
      // 根据之前的认证类型，重新发起对应认证
      if (this.defaultAuthType != 'picture') {
        this.auth();
      } else {
        this.pictureDeal();
      }
    },
    //我的考試
    wodekaoshi() {
      this.$router.push({ path: "/profile", query: { id: this.id } });
    },
    //点击开始考试（先认证，后创建会话）
    kaikao() {
      this.post('exam/checkExamAuth').then((res)=>{
        if(res.code == 1){
          if(res.data.isNeedAuth == 'authsuccess'){
            // 已认证，直接创建考试会话
            this.doStartExam();
          }else if(res.data.isNeedAuth == 'authing'){
            // 认证进行中
            sessionStorage.setItem('examIntent', 'true');
            this.checkAuth()
          }else{
            // 未认证，保存意图后弹出认证弹窗
            sessionStorage.setItem('examIntent', 'true');
            this.showAuthModal()
          }
        }
      })
    },
    // 创建考试会话并进入答题
    doStartExam() {
      sessionStorage.removeItem('examIntent');
      var url = "exam/examnum";
      let param = { study_id: this.id };
      this.post(url, param)
        .then((res) => {
          if (res.code != 0) {
            this.$router.push({ path: "/answer", query: { id: this.id } });
          }
        })
        .catch((err) => {});
    },
    //考试须知接口
    getexamtext() {
      let that = this;
      var url = "exam/examtext";
      let param = {};
      this.post(url)
        .then((res) => {
          this.extrm = res.data;
          // console.log(res);
        })
        .catch((err) => {
          // console.log(err);
        });
    },
  },
};
</script>
<style scoped>
@import "../../css/exam.css";
/* ========== 不可关闭失败弹窗样式 ========== */
.fail-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  pointer-events: auto;
}

.fail-modal-content {
  width: 85%;
  max-width: 340px;
  background-color: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  animation: modalFadeIn 0.2s ease-out;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.fail-modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px 16px 8px;
  font-size: 18px;
  font-weight: bold;
  color: #ff4d4f;
}

.fail-icon {
  font-size: 24px;
}

.fail-modal-body {
  padding: 16px 20px;
  text-align: center;
  color: #333;
  line-height: 1.5;
}

.fail-tip {
  margin-top: 12px;
  font-size: 12px;
  color: #999;
}

.fail-modal-footer {
  padding: 16px 20px 24px;
  display: flex;
  justify-content: center;
  gap: 12px;
}

.contact-btn,
.retry-auth-btn {
  border: none;
  border-radius: 30px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  flex: 1;
  max-width: 130px;
}

.contact-btn {
  background-color: #f0f0f0;
  color: #666;
}

.contact-btn:hover {
  background-color: #e0e0e0;
}

.retry-auth-btn {
  background-color: #1890ff;
  color: white;
}

.retry-auth-btn:hover {
  background-color: #40a9ff;
}
.simulate-btn {
  background-color: #52c41a;
  color: white;
  border: none;
  border-radius: 30px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  flex: 1;
  max-width: 130px;
}
.simulate-btn:hover {
  background-color: #73d13d;
}
</style>
